module.exports = __webpack_public_path__ + "static/media/wrong_icon.d1deac22.svg";